<template>
  <div class="commounity">
    <div class="box">
      <!-- 进入工单 -->
      <div class="titleSeacher">
        <el-dropdown @command="handleCommand">
          <div class="ticket">我的工单</div>
          <el-dropdown-menu slot="dropdown">
            <template
              v-if="isLogin && userInfoData?.bindAccountInfo.length > 0"
            >
              <el-dropdown-item
                v-for="item in userInfoData.bindAccountInfo"
                :key="item.organizationid"
                :command="item.organizationid"
                >{{ item.orgname }}:&nbsp;{{
                  item.organizationid
                }}</el-dropdown-item
              >
            </template>
            <template v-else>
              <el-dropdown-item> 请绑定CRM账号 </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 工单列表 -->
      <div class="cusTable">
        <div class="worklist" v-for="item in tableData.data" :key="item.id">
          <!-- 问题类型、编号、操作 -->
          <div class="operaBtn">
            <ul class="order">
              <li class="belong">{{ item.belongProductLabel }}</li>
              <li class="info-box">工单编号:&nbsp;{{ item.work_order_no }}</li>
            </ul>
            <div class="info-box">
              {{ item.replayNum }}个回复·最后回复人：{{ item.reply_account }}·{{
                item.reply_time
              }}
            </div>
          </div>
          <!-- 问题内容 -->
          <div class="content">
            {{ item.content }}
          </div>
          <!-- 信息、状态 -->
          <div class="info-box">
            <div class="info">提交人:&nbsp;{{ item.submitAccount }}</div>
            <div class="status">
              {{ item["workOrderStatustext"] }}
            </div>
          </div>
        </div>
      </div>
      <div class="showMore" @click="loadScroll">显示更多</div>
    </div>
  </div>
</template>

<script>
import mixin from "@/views/layout/mixin";
import * as Api from "./api";
import dayjs from "dayjs";
import { getDistanceDay } from "@/utils/distanceDay";
import {
  Popover,
  Message,
  Dropdown,
  DropdownItem,
  DropdownMenu,
} from "element-ui";
import dynamicTable from "@/components/Table/v-dynamicTable.vue";
export default {
  name: "community",
  mixins: [mixin],
  components: {
    "el-popover": Popover,
    "el-dropdown": Dropdown,
    "el-dropdown-item": DropdownItem,
    "el-dropdown-menu": DropdownMenu,
    dynamicTable,
  },
  data() {
    return {
      // 注册地址
      register: "./login/#/community/register",
      // 表格数据
      tableData: {
        data: [],
        title: [],
      },
      // 查询条件参数
      searchFormData: {
        pageNo: 1,
        pageSize: 10,
        condition: {},
      },
      indexPage: 1, // 页数++
      refreshDate: "", //刷新时间
      // 总页数
      totalPages: null,
    };
  },
  mounted() {
    // 查询工单
    this.getTableData();
  },
  methods: {
    /**进入工单 */
    handleCommand(command) {
      if (command) {
        // 进入到online
        let token = window.$CCDK.CCToken.getToken(
          "communityToken",
          "communityToken"
        );
        let orgId = command;
        window.open(
          `${window.Glod["ccex-online"]}/#/index/commounityLogin?accessToken=${token}&orgId=${orgId}`,
          "_blanck"
        );
      } else {
        return;
      }
    },
    /** 获取工单列表 */
    async getTableData() {
      // 请求
      await Api.pageIdea({ ...this.searchFormData }).then((res) => {
        // 数据
        if (res.data.list.length > 0) {
          res.data.list.forEach((item) => {
            // 状态
            item["workOrderStatustext"] = item["work_order_status"];
            // 提交人，时间
            item["submitAccount"] =
              item["submit_account"] +
              "," +
              dayjs(item["submit_time"]).format("YYYY-MM-DD HH:mm:ss");
            // 多长时间前
            item["reply_time"] = getDistanceDay(item["reply_time"]);
          });
        } else {
          Message.warning("没有更多了");
        }
        this.tableData.data = this.tableData.data.concat(res.data.list);
        // 总页数
        this.totalPages = res.data.totalPages;
      });
    },
    // 条件变化时
    dateChange() {
      const curDate = dayjs();
      if (curDate - this.refreshDate > 1000) {
        this.tableData = {
          data: [],
          title: [],
        };
        this.indexPage = 1;
        this.searchFormData.pageNo = 1;
        this.getTableData();
        this.refreshDate = curDate;
      }
    },
    // 滚动加载
    loadScroll() {
      if (this.indexPage <= this.totalPages) {
        const currentDate = dayjs();
        if (currentDate - this.refreshDate > 1000) {
          this.indexPage++;
          this.searchFormData.pageNo = this.indexPage;
          this.getTableData();
          this.refreshDate = currentDate;
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.commounity {
  padding-bottom: 20px;
  height: calc(100vh - 60px);
  overflow: auto;
  .box {
    height: 100%;
    width: 60%;
    margin: auto;
    // 头部
    header {
      height: 60px;
      padding: 10px 0px;
      /* background: #fff; */
      display: flex;
      justify-content: space-between;
      align-items: center;
      .user {
        cursor: pointer;
        .user-login {
          border: 1px solid #3e7af7;
          border-radius: 4px;
          padding: 2px 8px;
        }
      }
    }
    // 添加工单
    .titleSeacher {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 40px;
      .ticket {
        cursor: pointer;
        background: coral;
        color: #fff;
        border-radius: 4px;
        padding: 4px 12px;
      }
    }
    // 列表
    .cusTable {
      margin-top: 12px;
      // 工单
      .worklist {
        margin: 16px 0px;
        border-bottom: 1px solid #f5f5f5;
        .operaBtn {
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          padding: 4px 0px;
          .order {
            > li {
              display: inline-block;
              margin-right: 8px;
            }
            .belong {
              color: #fff;
              padding: 0px 4px;
              background: Coral;
              border-radius: 2px;
            }
          }
        }
        .content {
          width: 80%;
          font-size: 12px;
          color: orangered;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          cursor: pointer;
          padding: 2px 0px;
        }
        .info-box {
          font-size: 12px;
          color: #909399;
          display: flex;
          justify-content: space-between;
          padding: 4px 0px;
          .status {
            color: #fff;
            padding: 0px 4px;
            background: #409eff;
            border-radius: 2px;
          }
        }
      }
    }
    // 更多
    .showMore {
      cursor: pointer;
      text-align: center;
      color: #3e7af7;
      background: #f5f5f5;
      border-radius: 4px;
      padding: 4px 0px;
      font-size: 14px;
    }
  }
}
</style>
